import { Link } from 'react-router-dom';
import Logo from './Logo';

const Footer = () => {
  const handleNavClick = () => {
    window.scrollTo(0, 0);
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground text-background">
      {/* Tagline Banner */}
      <div className="bg-sage py-4">
        <p className="text-center text-xs sm:text-sm tracking-[0.15em] sm:tracking-[0.2em] text-sage-foreground font-semibold px-4">
          MORE VIEWS • NEW WAYS • INSPIRED OUTCOMES
        </p>
      </div>
      
      <div className="max-w-6xl mx-auto px-6 sm:px-8 py-12 sm:py-16">
        {/* Mobile: Centered stacked layout */}
        <div className="flex flex-col items-center text-center md:hidden">
          {/* Logo */}
          <div className="mb-6"><Logo variant="reversed" height={40} /></div>
          
          {/* Description */}
          <p className="text-sm leading-relaxed text-background/70 max-w-xs mb-8">
            We facilitate individual, team, and organizational transformation through
            developmental coaching and a life of ongoing practice.
          </p>
          
          {/* Navigation Links - Horizontal */}
          <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2 mb-8">
             <Link to="/" onClick={handleNavClick} className="text-sm text-background/70 hover:text-background transition-colors">Home</Link>
            <Link to="/ai-transformation" onClick={handleNavClick} className="text-sm text-background/70 hover:text-background transition-colors">AI Transformation</Link>
            <Link to="/about" onClick={handleNavClick} className="text-sm text-background/70 hover:text-background transition-colors">About</Link>
            <Link to="/services" onClick={handleNavClick} className="text-sm text-background/70 hover:text-background transition-colors">For Leaders</Link>
            <Link to="/for-organizations" onClick={handleNavClick} className="text-sm text-background/70 hover:text-background transition-colors">For Organizations</Link>
            <Link to="/testimonials" onClick={handleNavClick} className="text-sm text-background/70 hover:text-background transition-colors">Results</Link>
            <Link to="/essays" onClick={handleNavClick} className="text-sm text-background/70 hover:text-background transition-colors">Essays</Link>
          </nav>
          
          {/* Contact Info */}
          <div className="flex flex-col items-center gap-2 text-sm text-background/70 mb-8">
            <a href="mailto:support@paradoxedge.com" className="hover:text-background transition-colors">support@paradoxedge.com</a>
            <span>Denver, CO</span>
          </div>
          
          {/* Divider */}
          <div className="w-full border-t border-background/10 pt-6">
            {/* Legal Links */}
            <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 mb-4">
              <Link to="/terms" onClick={handleNavClick} className="text-xs text-background/50 hover:text-background/70 transition-colors">Terms</Link>
              <Link to="/privacy" onClick={handleNavClick} className="text-xs text-background/50 hover:text-background/70 transition-colors">Privacy</Link>
              <a href="https://www.kenthfrazier.com" target="_blank" rel="noopener noreferrer" className="text-xs text-background/50 hover:text-background/70 transition-colors">kenthfrazier.com</a>
            </div>
            
            {/* Copyright */}
            <p className="text-xs text-background/50">&copy; {currentYear} ParadoxEdge. All rights reserved.</p>
          </div>
        </div>

        {/* Desktop: Three-column grid */}
        <div className="hidden md:grid md:grid-cols-[1.2fr_1fr_1fr] gap-16">
          {/* Brand */}
          <div className="flex flex-col">
            <div className="mb-6"><Logo variant="reversed" height={36} /></div>
            <p className="text-sm leading-relaxed text-background/70">
              We facilitate individual, team, and organizational transformation through
              developmental coaching and a life of ongoing practice.
            </p>
          </div>

          {/* Navigation */}
          <div className="flex flex-col">
            <h4 className="text-sm font-semibold text-background uppercase tracking-wider mb-6">Explore</h4>
            <nav className="flex flex-col space-y-3">
              <Link to="/" onClick={handleNavClick} className="text-background/70 hover:text-background transition-colors">Home</Link>
              <Link to="/ai-transformation" onClick={handleNavClick} className="text-background/70 hover:text-background transition-colors">AI Transformation</Link>
              <Link to="/about" onClick={handleNavClick} className="text-background/70 hover:text-background transition-colors">About</Link>
              <Link to="/services" onClick={handleNavClick} className="text-background/70 hover:text-background transition-colors">For Leaders</Link>
              <Link to="/for-organizations" onClick={handleNavClick} className="text-background/70 hover:text-background transition-colors">For Organizations</Link>
              <Link to="/testimonials" onClick={handleNavClick} className="text-background/70 hover:text-background transition-colors">Results</Link>
              <Link to="/essays" onClick={handleNavClick} className="text-background/70 hover:text-background transition-colors">Essays</Link>
            </nav>
          </div>

          {/* Contact */}
          <div className="flex flex-col">
            <h4 className="text-sm font-semibold text-background uppercase tracking-wider mb-6">Connect</h4>
            <div className="flex flex-col space-y-3 text-background/70">
              <a href="mailto:support@paradoxedge.com" className="hover:text-background transition-colors">support@paradoxedge.com</a>
              <span>Denver, CO</span>
            </div>
          </div>
        </div>

        {/* Desktop Bottom Bar */}
        <div className="hidden md:flex border-t border-background/10 mt-12 pt-8 items-center justify-between">
          <p className="text-sm text-background/50">&copy; {currentYear} ParadoxEdge. All rights reserved.</p>

          <div className="flex items-center gap-6">
            <Link to="/terms" onClick={handleNavClick} className="text-sm text-background/50 hover:text-background/70 transition-colors">Terms of Service</Link>
            <Link to="/privacy" onClick={handleNavClick} className="text-sm text-background/50 hover:text-background/70 transition-colors">Privacy Policy</Link>
            <a href="https://www.kenthfrazier.com" target="_blank" rel="noopener noreferrer" className="text-sm text-background/50 hover:text-background/70 transition-colors">kenthfrazier.com</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
